import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab21dbf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "lable"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lable-left" }, "品牌：", -1))
const _hoisted_6 = { class: "lable-right" }
const _hoisted_7 = {
  key: 1,
  class: "lable"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lable-left" }, "型号：", -1))
const _hoisted_9 = { class: "lable-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "goods-item",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goto(_ctx.data.gid, _ctx.data.id)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.getImgUrl(_ctx.data.photo)
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", {
      class: "right",
      style: _normalizeStyle({ width: _ctx.itemWidth + 'px' })
    }, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.data.names), 1),
      (_ctx.data.brand)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.data.brand), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.data.model)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.data.model), 1)
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}